
import React, { useState } from 'react';
import { Movie } from '../types';

interface MovieCardProps {
  movie: Movie;
  onClick: (movie: Movie) => void;
}

const MovieCard: React.FC<MovieCardProps> = ({ movie, onClick }) => {
  const [imageError, setImageError] = useState(false);
  const showPlaceholder = !movie.posterUrl || imageError;

  return (
    <div
      className="glass-card rounded-2xl overflow-hidden cursor-pointer flex flex-col h-full border border-[color:var(--border)]"
      onClick={() => onClick(movie)}
    >
      <div className="relative aspect-[2/3] overflow-hidden bg-zinc-950">
        {showPlaceholder ? (
          <div className="absolute inset-0 p-8 flex flex-col justify-center items-center text-center bg-gradient-to-br from-zinc-900 via-black to-zinc-900">
            <div className="relative mb-6">
              <i className="fa-brands fa-google-drive text-[color:var(--text-ghost)] text-7xl opacity-40"></i>
              <div className="absolute inset-0 flex items-center justify-center">
                <i className="fa-solid fa-film text-[color:var(--text-ghost)] text-2xl animate-pulse"></i>
              </div>
            </div>
            <span className="text-[9px] font-black text-[color:var(--text-faint)] tracking-[0.4em] uppercase mb-2">Vault Entry</span>
            <p className="text-[10px] text-[color:var(--text-ghost)] font-bold uppercase tracking-widest px-4 border-t border-[color:var(--border)] pt-2">
              Encrypted File Storage
            </p>
          </div>
        ) : (
          <img
            src={movie.posterUrl}
            alt={`${movie.title} poster`}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
            onError={() => setImageError(true)}
          />
        )}

        <div className="absolute inset-0 poster-gradient opacity-90 pointer-events-none"></div>

        <div className="absolute bottom-0 left-0 right-0 p-5">
          <div className="flex justify-between items-center mb-1">
            <span className="text-[10px] font-bold text-[color:var(--accent)] tracking-[0.2em] uppercase">{movie.year}</span>
            <span className="text-[10px] text-[color:var(--text-faint)] uppercase tracking-widest">{movie.id.padStart(3, '0')}</span>
          </div>
          <h3 className="text-xl font-black leading-tight line-clamp-2 uppercase">
            {movie.title}
          </h3>
          <p className="text-xs text-[color:var(--text-muted)] mt-1 line-clamp-1 italic font-medium">
            Dir. {movie.director}
          </p>

          <div className="mt-6">
            <button
              className="w-full bg-[color:var(--accent)] text-[color:var(--accent-contrast)] py-3 rounded-xl text-xs font-black tracking-widest hover:bg-[color:var(--accent-hover)] transition-all flex items-center justify-center gap-2 shadow-2xl"
              onClick={(e) => {
                e.stopPropagation();
                window.open(movie.drive, '_blank');
              }}
            >
              WATCH NOW <i className="fa-solid fa-play text-sm"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
